/**
 * Colors_T32.jsx — Template 32 "Fresh Horizon" Design
 * Palette: Coral Orange · Ocean Teal · Warm White · Deep Slate
 */
import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
export const mapB2CTenantToLanding = (tenantData) => {
  const theme  = tenantData?.theme  || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero   = tenantData?.hero   || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
      companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId, 
    userId:          tenantData?.userId,
     logoUrl: getLocalLogoUrl(tenantData?.domain),
    companyName:     tenantData?.branding?.companyName  || 'Travel Agency',
    brandName:       tenantData?.branding?.brandName    || 'Travel Agency',
    
    // Contact
    email:           tenantData?.branding?.email        || 'travelagency@gmail.com',
     phones:      Array.isArray(tenantData?.branding?.phones)
                   ? tenantData?.branding?.phones[0]
                   : tenantData?.branding?.phones  || '9128341203',
    whatsapp:        tenantData?.branding?.whatsapp     || '9081212890',
    socials:         tenantData?.branding?.socials      || {},

     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,

    topBarBg:   topBar.bgColor   || theme.themeColor1 || theme.themecolor1,
    topBarText: topBar.textColor || '#FFFFFF',

    headerBg:   header.bgColor   || '#FFFFFF',
    headerText: header.textColor || '#0F2137',

    footerBg:   footer.bgColor   || '#0F2137',
    footerText: footer.textColor || '#94A3B8',

    heroData: {
      flights: {
        title:     hero.flights?.title     || 'Where to next?',
        subTitle:  hero.flights?.subTitle  || 'Search 500+ airlines. Find the perfect fare in seconds.',
        textColor: hero.flights?.textColor || '#FFFFFF',
        bgImage:   hero.flights?.bgImage   || 'https://images.unsplash.com/photo-1436491865332-7a61a109c0f3?q=80&w=1600',
      },
      hotels: {
        title:     hero.hotels?.title     || 'Find Your Dream Stay.',
        subTitle:  hero.hotels?.subTitle  || 'Handpicked hotels — from cozy boutiques to luxury resorts.',
        textColor: hero.hotels?.textColor || '#FFFFFF',
        bgImage:   hero.hotels?.bgImage   || 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?q=80&w=1600',
      },
      holidays: {
        title:     hero.holidays?.title     || 'Your Dream Holiday Awaits.',
        subTitle:  hero.holidays?.subTitle  || 'Curated packages for every kind of adventure.',
        textColor: hero.holidays?.textColor || '#FFFFFF',
        bgImage:   hero.holidays?.bgImage   || 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1600',
      },
      sightseeing: {
        title:     hero.sightseeing?.title     || 'Discover Every Wonder.',
        subTitle:  hero.sightseeing?.subTitle  || 'Guided tours, epic activities & once-in-a-lifetime experiences.',
        textColor: hero.sightseeing?.textColor || '#FFFFFF',
        bgImage:   hero.sightseeing?.bgImage   || 'https://images.unsplash.com/photo-1533105079780-92b9be482077?q=80&w=1600',
      },
    },
  };
};

export const getB2CColors_T32 = (landingData) => {
  const c1 = landingData.themeColor1 || '#F97316'; // Vibrant coral-orange
  return {
    theme1: c1,
    theme2: landingData.footerBg    || '#0F2137', // Deep slate navy
    theme3: landingData.headerBg    || '#FFFFFF', // Pure white header
    theme4: landingData.themeColor4 || '#FFF7F0', // Warm cream surface
    theme5: landingData.themeColor5 || '#FFFFFF',

    headerText: landingData.headerText || '#0F2137',
    footerText: landingData.footerText || '#94A3B8',
    topBarBg:   landingData.topBarBg   || c1,
    topBarText: landingData.topBarText || '#FFFFFF',

    teal:   '#0D9488', // Ocean teal accent
    amber:  '#F59E0B',
    rose:   '#F43F5E',
  };
};
